/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import ContainedResourcesNotification from 'App/Pages/Diagram/Deployment/executeModal/ContainedResourcesNotification';
import { processApplicationStore } from 'stores';

export default function ProcessApplicationResources() {
  const { processApplication, fromAProcessApplication } = processApplicationStore;

  return (
    fromAProcessApplication &&
    processApplication.files && <ContainedResourcesNotification resources={processApplication.files.length} />
  );
}
